import { isStaticFormParameters } from '@tmh-website/services/form.service';

import type { ETContactFormValues, ETContactFormProps } from './ETContactForm.contracts';
import type { PostSubmitContactForm } from '@tmh-website/services/electricity-tariff/electricity-tariff.types';

/**
 * Maps the `ETContactFormValues` to the object compliant with the back-end payload schema.
 *
 * @param values - Form values (handled by Formik).
 * @param props - Props passed to the `<ETContactForm>` component.
 */
export const mapValuesToPayload = (
  values: ETContactFormValues,
  props: ETContactFormProps
): PostSubmitContactForm['props'] => {
  const { formParameters } = props;

  if (!isStaticFormParameters(formParameters)) {
    throw new Error(`Expected the 'formParameters' to be compliant with the 'StaticFormParameters' interface!`);
  }

  const { adminEmail } = formParameters.params;

  const { email: clientEmail, firstName, gRecaptchaResponse, issueType, lastName, message, phone } = values;

  return {
    adminContactDetails: {
      email: adminEmail,
    },
    contactDetails: {
      email: clientEmail,
      phone,
    },
    gRecaptchaResponse,
    issueType,
    message,
    personalDetails: {
      firstName,
      lastName,
    },
  };
};
